import { useRef } from 'react';

import { payrunTypeItems } from '@xemplo/gp-types';
import { DawnTriangleAlert } from '@xemplo/icons';
import { SelectRefCallback, TextDropdownMultiV2 } from '@xemplo/text-dropdown-multi';

import { TestIds } from '../create-payrun-approver-test.helper';

import { ModalBodyProps } from './create-payrun-approvers-form.types';
import * as S from './modal-styles';
import { useModalBody } from './use-modal-body';

export const ModalBody = (props: Readonly<ModalBodyProps>) => {
  const { errorMessage } = props;

  const { payschedulesData, isPayScheduledEnabled, usersData } = useModalBody(props);
  const payscheduleRef = useRef<SelectRefCallback>(null);

  return (
    <S.StyledForm>
      <S.FormLabel>
        Pay run type
        <TextDropdownMultiV2
          name="payrunType"
          items={payrunTypeItems}
          isDropdownMulti={false}
          selectProps={{ placeholder: 'Select type' }}
          testId={TestIds.PayrunTypeId}
          rules={{ required: 'This field is required' }}
          onChange={() => {
            if (!payscheduleRef.current || isPayScheduledEnabled) return;
            payscheduleRef.current.setSelectedKeys([]);
          }}
        />
      </S.FormLabel>

      <S.FormLabel>
        Specific Pay Schedule(s)
        <TextDropdownMultiV2
          name="paySchedules"
          ref={payscheduleRef}
          items={payschedulesData ?? []}
          isDropdownMulti={true}
          selectProps={{ placeholder: 'Select pay schedule(s)' }}
          displayProps={{ isDisabled: !isPayScheduledEnabled }}
          testId={TestIds.PayScheduleId}
        />
      </S.FormLabel>

      <S.FormLabel>
        Approver(s)
        <TextDropdownMultiV2
          name="selectedUsers"
          items={usersData}
          isDropdownMulti={true}
          selectProps={{ placeholder: 'Select company user(s)' }}
          testId={TestIds.SelectedUsers}
          rules={{
            required: 'This field is required',
            value: [],
            validate: (value) => {
              if (!value || value.length === 0) {
                return 'This field is required';
              }
              return true;
            },
          }}
        />
      </S.FormLabel>

      {errorMessage ? (
        <S.ErrorMessage>
          <DawnTriangleAlert />
          {errorMessage}
        </S.ErrorMessage>
      ) : null}
    </S.StyledForm>
  );
};
